import { render } from "./bill_saldo_master.vue?vue&type=template&id=594f52c2&scoped=true"
import script from "./bill_saldo_master.vue?vue&type=script&lang=js"
export * from "./bill_saldo_master.vue?vue&type=script&lang=js"

import "./bill_saldo_master.vue?vue&type=style&index=0&id=594f52c2&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594f52c2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSelect,QTr,QTh,QTd});
